import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ViewChild, TemplateRef } from '@angular/core';
import { isSameDay, isSameMonth } from 'date-fns';
import { Subject } from 'rxjs';
import {
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import {
  CalendarDayViewBeforeRenderEvent,
  CalendarMonthViewBeforeRenderEvent,
  CalendarWeekViewBeforeRenderEvent,
} from 'angular-calendar';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CalendarService } from './calendar.service';
import { RecordPageComponent } from 'src/app/layout/record-page/record-page.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { LayoutService } from 'src/app/layout/layout.service';
import { DragAndDropModule } from 'angular-draggable-droppable';
import * as moment from 'moment';
import * as g from 'src/app/globals';
import * as util from './common/util';
import { RRule, Options } from 'rrule';
import { ActivityType, CalendarEvent, EventAction, EventColor, MoreEventStyles, RecurringEvent, ViewPeriod, colors } from './common/ICalendar';
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.less'],
})
export class CalendarComponent implements OnInit {
  isFilter: boolean;
  isCalenderLoading: boolean;
  savedDate;
  activityId: string | number;
  constructor(
    private modal: NzModalService,
    private calendarService: CalendarService,
    private drawerService: NzDrawerService,
    private layoutService: LayoutService,
    private msg: NzMessageService,
    private cdr: ChangeDetectorRef
  ) { }

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate = moment().toDate();
  modalData: {
    action: string;
    event: CalendarEvent;
  };
  color: any;
  eventList: any;
  // eventBase: CalendarEvent[];
  events: any[] = [];
  moreEvents: CalendarEvent[] = [];
  dayEvent: any[] = [];
  dayEventDate: Date;
  EVENT_LIMIT = 2;
  recurringEvents: RecurringEvent[] = [];
  isLoading = true;
  showFilter = true;
  public activityTypeList: ActivityType[];
  selectedActivityType = [];
  selectedUsers = [];
  calendarWidth = '14';
  dayEventWidth = '4';
  usersList: any[];
  usersListCount: any;
  language = '';
  showDelete = false;
  showEdit = false;
  viewPeriod: ViewPeriod;
  moreEventStyles: MoreEventStyles;

  // tslint:disable-next-line: member-ordering
  actions: CalendarEventAction[] = [
    {
      label: `<span class="edit-icon"> </span>`,
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        // this.handleEvent('Edited', event);
        this.navigateTo(25, event.id);
      },
    },
  ];

  // tslint:disable-next-line: member-ordering
  refresh: Subject<any> = new Subject();

  activeDayIsOpen = false;

  ngOnInit(): void {
    document.addEventListener('dblclick', (e) => {
      console.log(e);
      if (this.savedDate != null) {
        this.handleWeekDblClick();
      }
      if (this.activityId != null) {
        this.navigateTo(25, this.activityId);
        this.activityId = null;
      }
    }, false);
    moment.updateLocale('en', {
      week: {
        dow: 1, // set start of week to monday instead
        doy: 0,
      },
    });

    this.color = colors;
    this.language = g.language;
    this.activityTypeList = [
      { id: 'C', text: 'Call', icon: 'phone' },
      { id: 'M', text: 'Meeting', icon: 'deployment-unit' },
      { id: 'T', text: 'Task', icon: 'unordered-list' },
      { id: 'E', text: 'E-Mail', icon: 'mail' },
      { id: 'P', text: 'book', icon: 'book' },
      { id: 'N', text: 'cloud', icon: 'cloud' },
    ];
    this.layoutService.executeQuery(2082, {}).subscribe((result: any[]) => {
      this.usersList = result;
      this.usersListCount = this.usersList;
    });
    const userId = g.userIdentity.UserSign;
    this.selectedUsers.push(userId);

    this.getEventsList();
  }
  handleMoreEvent(e: any, events: any) {
    this.dayEvent = events;
    console.log('dayEvent', this.dayEvent);
  }
  transform(value: string): string {
    if (!value) {
      return '';
    }
    return value.split('<br/>')[0];
  }

  getEventsList() {
    this.isCalenderLoading = true;
    // this.selectedUsers = this.usersList.map(x => x.Code);
    const data = [this.selectedActivityType, this.selectedUsers];
    this.calendarService
      .getEvents('Calendar/RecurrCalendarEvents', data)
      .subscribe((eventList: any[]) => {
        console.log('eventList', eventList);
        this.events = [];
        this.eventList = [];
        this.recurringEvents = [];
        this.eventList = eventList;
        // this.eventBase = JSON.parse(eventList);
        // this.eventList = JSON.parse(this.eventList);
        this.eventList.forEach((evntInfo) => {
          if (evntInfo.rrule === undefined) {
            this.events.push({
              id: evntInfo.id,
              start: new Date(evntInfo.start),
              end: new Date(evntInfo.end),
              title: evntInfo.title,
              titleToDisplay: evntInfo.titleToDisplay,
              color: colors[evntInfo.className[1].replace(/['"]+/g, '')],
              actions: this.actions,
              allDay: evntInfo.allDay,
              resizable: {
                beforeStart: true,
                afterEnd: true,
              },
              draggable: true,
              isRecur: false,
              icon: evntInfo.icon.substring(3),
              AttendTo: evntInfo.AttendTo,
              BPName: evntInfo.BPName,
              className: evntInfo.className
            });
          } else {
            let rrule: any;
            console.log('evntInfo.rrule', evntInfo.rrule);
            if (evntInfo.rrule.freq === 'daily') {
              console.log('.rrule.daily', evntInfo.rrule);
              evntInfo.rrule.freq = RRule.DAILY;
              rrule = {
                freq: RRule.DAILY,
              };
            } else if (evntInfo.rrule.freq === 'weekly') {
              const byweekday = [];
              evntInfo.rrule.byweekday.forEach((day) => {
                if (day === 'mo') {
                  byweekday.push(RRule.MO);
                }
                if (day === 'tu') {
                  byweekday.push(RRule.TU);
                }
                if (day === 'we') {
                  byweekday.push(RRule.WE);
                }
                if (day === 'th') {
                  byweekday.push(RRule.TH);
                }
                if (day === 'fr') {
                  byweekday.push(RRule.FR);
                }
                if (day === 'sa') {
                  byweekday.push(RRule.SA);
                }
                if (day === 'su') {
                  byweekday.push(RRule.SU);
                }
              });

              // rrule = {
              evntInfo.rrule.freq = RRule.WEEKLY;
              evntInfo.rrule.byweekday = byweekday;
              // };
            } else if (evntInfo.rrule.freq === 'monthly') {
              console.log('.rrule.monthly', evntInfo.rrule);
              // rrule = {
              evntInfo.rrule.freq = RRule.MONTHLY;
              evntInfo.rrule.bymonthday = evntInfo.rrule.bymonthday - 1;
              // };
            } else if (evntInfo.rrule.freq === 'yearly') {
              console.log('.rrule.yearly', evntInfo.rrule);
              // rrule = {
              evntInfo.rrule.freq = RRule.YEARLY;
              evntInfo.rrule.bymonth = evntInfo.rrule.bymonth[0];
              evntInfo.rrule.bymonthday = evntInfo.rrule.bymonthday - 1;
              // };
            }
            this.recurringEvents.push({
              id: evntInfo.id,
              title: evntInfo.title,
              titleToDisplay: evntInfo.titleToDisplay,
              icon: evntInfo.icon.substring(3),
              start: new Date(evntInfo.start),
              end: new Date(evntInfo.end),
              color: colors[evntInfo.className[1].replace(/['"]+/g, '')],
              rrule: evntInfo.rrule,
            });
          }
        });
        this.refresh.next();
        this.isLoading = false;
        console.log('this.eventList', this.eventList);
        console.log('this.events', this.events);
        this.isCalenderLoading = false;
      });
  }

  dayClicked({ date, events }: { date: Date; events: any[] }): void {
    console.log(events, date);
    this.dayEvent = events;
    console.log('dayEvent', this.dayEvent);
    this.dayEventDate = date;
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event, newStart, newEnd);
  }

  handleEvent(
    action: string,
    event: CalendarEvent,
    newStart: Date = null,
    newEnd: Date = null
  ): void {
    this.modalData = { event, action };
    console.log('afterDragevent', event, action);
    // this.modal.openModals(this.modalContent, { size: 'lg' });
    if (action === 'Clicked') {
      this.activityId = event.id;
      // this.navigateTo(25, event.id);
    } else if (action === 'Edited') {
      this.navigateTo(25, event.id);
    } else if (action === 'Deleted') {
      this.showDelete = true;
      this.modal.confirm({
        nzTitle: '<i>Do you Want to delete these items?</i>',
        nzContent: this.modalContent,
        nzOnOk: () => new Promise((resolve) => setTimeout(resolve, 1000)),
      });
    } else if (action === 'Dropped or resized') {
      this.DrageUpdateEvent(event, newStart, newEnd);
    }
  }
  recordPageDrawerClosed() {
    console.log('closed');

    this.getEventsList();
  }
  DrageUpdateEvent(event, newStart: Date = null, newEnd: Date = null) {
    const data = {
      id: event.id,
      start: newStart.getTime() / 1000, // new Date(event.start).valueOf() ,//1617282840,
      duration: newEnd.getTime() / 1000 - newStart.getTime() / 1000,
      end: newEnd.getTime() / 1000,
      allDay: event.allDay,
    };
    console.log('data', data);
    console.log('old Event data: ', event);

    this.calendarService
      .updateEvent('Calendar/UpdateActivity', data)
      .subscribe((result: any) => {
        console.log('eventList', result);
        if (result.Has_Error) {
          this.msg.error(this.layoutService.translate(result.Error_Message));
          this.getEventsList();
        } else {
          this.msg.success(
            this.layoutService.translate(
              `<i nz-icon [nzType]="'check-circle'" [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"></i>` +
              'Event ' +
              result.Resault_Value +
              ' Updated Successfully'
            )
          );
        }
        // debugger;
        this.refresh.next();
      });
  }

  navigateTo(model, id = null, recordModel = null) {
    if (id === null) {
      RecordPageComponent.openRecordPage(this.drawerService, {
        actionType: 'Add',
        drawerTitle: `Add Activity`,
        inDrawer: true,
        moduleId: Number(model),
        parentComponent: this,
        recordId: undefined,
        recordModel: recordModel != null ? recordModel : undefined,
      });
    } else {
      RecordPageComponent.openRecordPage(this.drawerService, {
        actionType: 'Edit',
        drawerTitle: `Activity: ${id}`,
        inDrawer: true,
        moduleId: Number(model),
        parentComponent: this,
        recordId: id,
        recordModel: recordModel != null ? recordModel : undefined,
      });
    }
  }

  objectSubmitted(event) {
    console.log('submited');
    this.ngOnInit();
  }

  addEvent(): void {
    this.navigateTo(25, null);
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  linkedObjectSubmitted($event, args){}

  btnFilter() {
  }

  filter(view) {
    this.isFilter = true;
    this.dayEvent = [];
    console.log('selectedActivityType', this.selectedActivityType);
    console.log('selectedUsers', this.selectedUsers);


    this.getEventsList();
  }

  updateCalendarEvents(
    viewRender:
      | CalendarMonthViewBeforeRenderEvent
      | CalendarWeekViewBeforeRenderEvent
      | CalendarDayViewBeforeRenderEvent
  ): void {

    if (
      !this.viewPeriod ||
      this.isFilter ||
      !moment(this.viewPeriod.start).isSame(viewRender.period.start) ||
      !moment(this.viewPeriod.end).isSame(viewRender.period.end)
    ) {
      this.isFilter = false;

      this.viewPeriod = viewRender.period;
      this.events = this.events.filter((el) => el.isRecur === false);
      this.recurringEvents.forEach((event) => {
        const rule: RRule = new RRule({
          ...event.rrule,
          dtstart: moment(event.rrule.dtstart).startOf('day').toDate(),
          until: moment(viewRender.period.end).endOf('day').toDate(),
        });
        const { id, title, titleToDisplay, color, icon } = event;

        rule.all().forEach((date) => {
          this.events.push({
            id,
            description: title,
            title: titleToDisplay,
            titleToDisplay,
            color,
            icon,
            start: moment(date).toDate(),
            isRecur: true,
          });
        });
      });

      this.cdr.detectChanges();
    }
  }
  onDoubleClick(event) {
    const recordModel = util.AtcivityRecordModel(event.date);
    this.navigateTo(25, null, recordModel);
  }
  saveDateAfterFirstClick(event) {
    console.log('test', event);
    this.savedDate = event.date;
  }
  handleWeekDblClick() {
    const recordModel = util.AtcivityRecordModel(this.savedDate, true);
    this.navigateTo(25, null, recordModel);
    this.savedDate = null;
  }
}
